import { ServiceDefinition } from '@pershing/pershing-core';

export class QuoteToggleServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;

    uri = 'quotetoggle';
    version = 'v1';
    family = 'netx360';
    appName = 'quotetoggle-svc';
    serviceName = 'app';
    mnemonic = 'nxp';

    static getInstance(): ServiceDefinition {
        if (!QuoteToggleServiceDefinition.instance) {
            QuoteToggleServiceDefinition.instance = new QuoteToggleServiceDefinition();
        }
        return QuoteToggleServiceDefinition.instance;
    }

    private constructor() {}

}
